import { render, staticRenderFns } from "./TokenEditCustom.vue?vue&type=template&id=effdb160&scoped=true"
import script from "./TokenEditCustom.vue?vue&type=script&lang=js"
export * from "./TokenEditCustom.vue?vue&type=script&lang=js"
import style0 from "./TokenEditCustom.vue?vue&type=style&index=0&id=effdb160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effdb160",
  null
  
)

export default component.exports